import { Toggle } from "@base-ui/react/toggle";
import { ToggleGroup as BaseToggleGroup } from "@base-ui/react/toggle-group";
import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./ToggleGroup.module.css";

export interface ToggleOption<Value extends string> {
  value: Value;
  label: ReactNode;
}

export interface ToggleGroupProps<Value extends string> {
  /** Names the group for assistive technology ("Suppliers shown"). */
  label: string;
  options: ReadonlyArray<ToggleOption<Value>>;
  /** The options switched on. */
  value: readonly Value[];
  onValueChange: (value: Value[]) => void;
  className?: string;
}

/**
 * Filter chips that each switch one option on or off, several at once (Base UI ToggleGroup), for
 * filters whose options all fit on screen. Arrow keys move between the chips; Space or Enter
 * switches one.
 */
export function ToggleGroup<Value extends string>({
  label,
  options,
  value,
  onValueChange,
  className,
}: ToggleGroupProps<Value>) {
  return (
    <BaseToggleGroup
      multiple
      aria-label={label}
      value={value}
      onValueChange={(next) => onValueChange(next)}
      className={clsx(styles.group, className)}
    >
      {options.map((option) => (
        <Toggle key={option.value} value={option.value} className={styles.toggle}>
          {option.label}
        </Toggle>
      ))}
    </BaseToggleGroup>
  );
}
